'use client';

import { useTranslations } from '@/hooks/useTranslations';

export function TermsOfServiceContent() {
  const t = useTranslations('Terms');

  const sections = [
    { titleKey: 'section1Title', contentKey: 'section1Content' },
    { titleKey: 'section2Title', contentKey: 'section2Content' },
    { titleKey: 'section3Title', contentKey: 'section3Content' },
    { titleKey: 'section4Title', contentKey: 'section4Content' },
    { titleKey: 'section5Title', contentKey: 'section5Content' },
    { titleKey: 'section6Title', contentKey: 'section6Content' },
    { titleKey: 'section7Title', contentKey: 'section7Content' },
  ];

  return (
    <div className="max-w-3xl mx-auto px-5 py-16">
      <h1 className="text-3xl font-bold mb-2">{t('title')}</h1>
      <p className="text-sm text-muted-foreground mb-10">{t('lastUpdated')}</p>
      <p className="text-muted-foreground mb-10 leading-relaxed">
        {t('intro')}
      </p>

      <div className="space-y-10">
        {sections.map((section, index) => (
          <section key={index}>
            <h2 className="text-xl font-semibold mb-3">
              {t(section.titleKey)}
            </h2>
            <p className="text-muted-foreground leading-relaxed whitespace-pre-line">
              {t(section.contentKey)}
            </p>
          </section>
        ))}
      </div>

      <p className="mt-12 text-sm text-muted-foreground">{t('contact')}</p>
    </div>
  );
}
